<template>
  <div>
    <v-form v-model="valid" class="pl-3 pr-3" ref="form" :lazy-validation="false">
      <h1>{{ $t('Owner') }}</h1>
      <v-layout row wrap>
        <v-flex sm6>
          <v-text-field class="pr-5"
                        :label="$t('First name')"
                        v-model="fields.firstname"
                        :rules="nameRules"
                        required></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-text-field xs6
                        :label="$t('Last name')"
                        v-model="fields.lastname"
                        :rules="nameRules"
                        required></v-text-field>
        </v-flex>
        <v-flex sm8 class="pr-5">
          <v-text-field
            :label="$t('Address and housenumber')"
            v-model="fields.address"
            :rules="nameRules"
            required></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field
            :label="$t('Postal code')"
            v-model="fields.postalcode"
            :rules="nameRules"
            required></v-text-field>
        </v-flex>
        <v-flex sm6 class="pr-5">
          <v-text-field
            :label="$t('City')"
            v-model="fields.city"
            :rules="nameRules"
            required></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-autocomplete
            :label="$t('Country')"
            :items="countries"
            v-model="fields.country"
            :max-height="600"
            ></v-autocomplete>
        </v-flex>
        <v-flex sm6 class="pr-5">
          <v-text-field
            :label="$t('Email')"
            v-model="fields.email"
            :rules="emailRules"
            required></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-text-field
            :label="$t('Phone number')"
            v-model="fields.phone"
            :rules="nameRules"
            required></v-text-field>
        </v-flex>
      </v-layout>
      <dog-component @update="(value) => { updateDog(dogIdx, value) }"
                     :isLast="parseInt(dogIdx, 10) === lastDogIdx"
                     :id="parseInt(dogIdx, 10)"
                     :key="dogIdx"
                     @delete="deleteDog"
                     :events="events"
                     v-for="dogIdx in Object.keys(dogs)" v-model="dogs[dogIdx]">
      </dog-component>
      <div class="text-xs-right">
        <v-btn @click="addDog" class="mt-5">{{ $t('Add another dog') }}</v-btn>
      </div>
      <h1 class="mt-5">{{ $t('Additional choices') }}</h1>
      <v-text-field
      v-if="$config.options.camping"
                class="camping-field"
        :label="`${$t('Amount of tent/caravan/camper')} ${$t('Friday - Sunday')}
          ${formatCurrency(settings.camping)} ${$t('per piece per weekend')}`"
        v-model="fields.campsite"
        type="number"
        :hint="`${$t('Including free shower facilities')}`"
                    persistent-hint

        :rules="numberRules"

      ></v-text-field>

      <v-text-field
        v-if="$config.options.dinner"
        :label="$t('Dinner club evening, per person') + ' ' + formatCurrency(settings.dinner)"
        v-model="fields.dinnerguests"
        type="number"
        :rules="numberRules"
      ></v-text-field>
      <v-text-field
      v-if="$config.options.magazine"
        :label="$t('Briardweekend/selection magazine') + ' ' + formatCurrency(settings.magazine)"
        v-model="fields.magazine"
        type="number"
        :rules="currencyRules"
      ></v-text-field>
      <v-text-field
        v-if="$config.options.donation"
        :label="$t('Donation (optional)')"
        v-model="fields.donation"
        type="number"
        :rules="currencyRules"
      ></v-text-field>

      <div class="subtotal mt-3">

        <h1 class="mb-1">{{ $t('Costs')}}</h1>
        <v-data-table
          :items="costs"
          class="elevation-1"
          hide-actions
          hide-headers
        >
          <template v-slot:items="props">
            <td>{{ props.item.label }}</td>
            <td class="text-xs-right" style="font-weight: bold">
              {{ formatCurrency(props.item.costs) }}</td>
          </template>
          <template v-slot:footer>
            <td><strong>{{ $t('Total costs') }}</strong></td>
            <td class="text-xs-right"><strong>{{ formatCurrency(totalCost) }}</strong></td>
          </template>
        </v-data-table>
      </div>
      <br/><br/>


      <v-checkbox v-model="fields.email_permission"
                  :label="$t('Contact me about future events')"></v-checkbox>
      <v-checkbox :rules="nameRules" :label="$t('I agree to the terms and conditions') ">
      </v-checkbox>
      <TermsAndConditions :lang="lang"/><br />

      <v-btn
        @click="submit"
        color="info"
      >
        {{ $t('submit & proceed to payment') }}
      </v-btn>
      <div style="display: inline-block">
        <img src="static/ideal.svg" class="logo">
        <img src="static/amex.svg" class="logo">
        <img src="static/visa.svg" class="logo">
        <img src="static/mastercard.svg" class="logo">
      </div>
      <br /><br />

      <div class="text-xs-right">
      <v-btn
        @click="reset"
        color="error"
      >
        {{ $t('Reset form') }}
      </v-btn></div>
    </v-form>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import 'moment/min/locales';
import Vue from 'vue';
import VuePersist from 'vue-persist';
import countries from 'i18n-iso-countries';
import config from '../config';
import { generateEvents } from '../events';


import DogComponent from './DogComponent';
import TermsAndConditions from './TermsAndConditions';
// Support french & english languages.
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/nl.json'));
countries.registerLocale(require('i18n-iso-countries/langs/de.json'));

Vue.use(VuePersist, { name: `persist:${config.date}` });

export default {
  components: { TermsAndConditions, DogComponent },
  name: 'form-component',
  persist: ['fields', 'dogs'],
  data() {
    return this.getDefaultData();
  },
  props: {
    lang: {
      type: String,
      default: 'nl',
    },
  },
  watch: {
    menu(val) {
      return val && this.$nextTick(() => {
        this.$refs.picker.activePicker = 'YEAR';
      });
    },
    is_member(val) {
      if (val) {
        this.become_member = false;
      }
    },
    dogs: {
      deep: true,
      handler() {
        this.updateApplicableForDiscount();
      },
    },
  },
  computed: {
    membershipCost() {
      return this.fields.country === 'NL' ? 3750 : 4250;
    },
    membershipLabel() {
      const costs = this.membershipCost;
      const membershipCosts = this.formatCurrency(costs);
      return `${this.$t('Become a NBC member')} ${membershipCosts}`;
    },
    colors() {
      return [
        this.$t('Black'), this.$t('Grey'), this.$t('Fawn'),
      ];
    },
    difference() {
      return moment(this.daydate).diff(this.date, 'months', true);
    },
    lastDogIdx() {
      return Math.max.apply(null, Object.keys(this.dogs).map(m => parseInt(m, 10)));
    },
    countries() {
      return Object.entries(countries.getNames(this.lang))
        .sort((a, b) => a[1].localeCompare(b[1]))
        .map(item => ({ value: item[0], text: item[1] }));
    },
    costs() {
      const costLines = [];
      Object.keys(this.dogs).forEach((dogIdx) => {
        let dogCosts = 0;
        if (this.dogs[dogIdx].events) {
          Object.keys(this.dogs[dogIdx].events).forEach((eventKey) => {
            const eventValue = this.dogs[dogIdx].events[eventKey];
            const event = this.events.find(e => e.keyword === eventKey);
            if (!event) return;
            const eventChoice = event.choices.find(e => e.keyword === eventValue);
            if (eventChoice && eventChoice.cost) {
              dogCosts += eventChoice.cost;
            }
            if (eventChoice && eventChoice.discountMultipleDogs && this.dogs[dogIdx].discountMultipleDogs) {
              dogCosts -= this.$config.discount.multipleDogs;
            }
          });
        }
        if (this.dogs[dogIdx].discountMultipleEventsPerDog) {
          dogCosts -= this.$config.discount.multipleEventsPerDog;
        }
        costLines.push(
          {
            label: `${this.$t('Dog')}: ${this.dogs[dogIdx].name}`,
            costs: dogCosts,
          },
        );
      });

      if (this.campingCost > 0) {
        costLines.push(
          {
            label: `${this.$t('Camping')} ${this.$t('Friday - Sunday')}`,
            costs: this.campingCost,
          },
        );
      }
      if (this.campingCostMonday > 0) {
        costLines.push(
          {
            label: `${this.$t('Camping')} ${this.$t('Friday - Monday')}`,
            costs: this.campingCostMonday,
          },
        );
      }


      if (this.dinnerCost > 0) {
        costLines.push(
          {
            label: this.$t('Dinner'),
            costs: this.dinnerCost,
          },
        );
      }

      if (this.lunchCost > 0) {
        costLines.push(
          {
            label: this.$t('Lunch'),
            costs: this.lunchCost,
          },
        );
      }

      if (this.donationCost > 0) {
        costLines.push(
          {
            label: this.$t('Donation'),
            costs: this.donationCost,
          },
        );
      }
      if (this.magazineCost > 0) {
        costLines.push(
          {
            label: this.$t('Magazine'),
            costs: this.magazineCost,
          },
        );
      }
      return costLines;
    },
    totalCost() {
      return this.costs.map(v => v.costs).reduce((total, line) => total + line);
    },
    lunchCost() {
      const value = parseInt(this.fields.lunchguests, 10) * this.settings.lunch;
      return !isNaN(value) ? value : 0;
    },
    dinnerCost() {
      const value = parseInt(this.fields.dinnerguests, 10) * this.settings.dinner;
      return !isNaN(value) ? value : 0;
    },
    magazineCost() {
      const value = parseInt(this.fields.magazine, 10) * this.settings.magazine;
      return !isNaN(value) ? value : 0;
    },
    donationCost() {
      const value = parseFloat(this.fields.donation) * 100;
      return !isNaN(value) ? value : 0;
    },
    campingCost() {
      const value = parseInt(this.fields.campsite, 10) * this.settings.camping;
      return (!isNaN(value) ? value : 0);
    },
    campingCostMonday() {
      const value = parseInt(this.fields.campsiteMonday, 10) * this.settings.campsiteMonday;
      return (!isNaN(value) ? value : 0);
    },
    settings() {
      return this.$config.cost;
    },
  },
  mounted() {
  },
  methods: {
    updateApplicableForDiscount() {
      let applyToNextDogs = false;
      Object.keys(this.dogs).forEach((dogIdx) => {
        if (this.dogs[dogIdx].events) {
          Object.keys(this.dogs[dogIdx].events).forEach((eventKey) => {
            const eventValue = this.dogs[dogIdx].events[eventKey];

            const event = this.events.find(e => e.keyword === eventKey);
            console.log(event);
            if (!event.discountMultipleDogs) return;

            const eventChoice = event.choices.find(e => e.keyword === eventValue);
            // nothing is chosen..
            if (!eventChoice) return;

            console.log(applyToNextDogs);
            if (applyToNextDogs) {
              this.$set(this.dogs[dogIdx], 'discountMultipleDogs', true);
            } else {
              this.$set(this.dogs[dogIdx], 'discountMultipleDogs', false);
            }
            if (eventChoice.discountMultipleDogs) {
              applyToNextDogs = true;
            }
          });
        }
      });
    },
    getDefaultData() {
      return {
        fields: {
          firstname: '',
          lastname: '',
          address: '',
          postalcode: '',
          city: '',
          country: 'NL',
          email: '',
          phone: '',
          nbc_member: false,
          donation: 0,
          is_member: false,
          lang: this.lang,
          email_permission: false,
          campsite: 0,
          campsiteMonday: 0,
          dinnerguests: 0,
          magazine: 0,
        },
        is_member_label: this.$t('I am a member of the Nederlandse Briard Club'),
        valid: false,
        nameRules: [
          v => !!v || this.$t('Required'),
        ],
        // config.costs..

        emailRules: [
          v => !!v || this.$t('E-mail is required'),
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('E-mail must be valid'),
        ],
        numberRules: [
          v => v >= 0 || this.$t('Number is required'),
          v => !isNaN(parseFloat(v, 10)) || this.$t('Number is required'),
          // v => v === '1' || this.$t('Test'),
        ],
        currencyRules: [
          v => !isNaN(parseFloat(v, 10)) || this.$t('Valid amount is required'),
          // v => v === '1' || this.$t('Test'),
        ],
        dogs: {
          0: {},
        },
        events: generateEvents(this.$t),
      };
    },


    updateDog(idx, value) {
      this.$set(this.dogs, idx, value);
    },
    deleteDog(idx) {
      this.$delete(this.dogs, idx);
    },
    addDog() {
      const max = this.lastDogIdx;
      const newIdx = max + 1;
      this.$set(this.dogs, newIdx, {});
      this.dogs[newIdx] = {};
    },
    between(a, b) {
      return this.difference >= a && this.difference <= b;
    },
    olderThan(a) {
      return this.difference >= a;
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    formatCurrency(num) {
      // Create our number formatter.
      const formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        // the default value for minimumFractionDigits depends on the currency
        // and is usually already 2
      });
      return formatter.format(num / 100);
    },
    reset() {
      // eslint-disable-next-line no-alert
      if (window.confirm(this.$t('Are you sure you want to delete all data and attachments?'))) {
        // todo: remove attachments from the server
        window.localStorage.clear();
        this.$data = location.reload();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        const data = {
          fields: this.fields,
          dogs: this.dogs,
          totalCost: this.totalCost,
          costLines: this.costLines,
          lang: this.lang,
        };

        // somehow: xdebug is not triggering on this request..
        return axios.post(`${config.urlPrefix}/submission`, data)
          .then((response) => {
            // window.localStorage.clear();
            if (response.data.redirect) {
              window.location = response.data.redirect;
            } else {
              alert('Redirect was not set!');
            }
          }).catch((err) => {
            // eslint-disable-next-line no-alert
            alert(`Something went wrong submitting this form! ${err}`);
          });
      }
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .logo {
    height: 35px;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: -15px;
  }
  .camping-field {
    margin-bottom: 20px;
    .v-messages.error--text
    {
      .v-messages__message {
        font-weight: normal;
      }
    }
      .v-messages__message {
        font-weight: bold;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/FormComponent.vue